import { ICustomer } from '@framework/ui/Pages/Landing/Sections/Customers';
import airFranceLogo from '@framework/assets/customers/svg/airFrance.svg';
import americanAirlinesLogo from '@framework/assets/customers/svg/americanAirlines.svg';
import barclaysLogo from '@framework/assets/customers/svg/barclays.svg';
import bnpParibasLogo from '@framework/assets/customers/svg/bnpParibas.svg';
import chuckCheeseLogo from '@framework/assets/customers/svg/chuckCheese.svg';
import creditAgricoleLogo from '@framework/assets/customers/svg/creditAgricole.svg';
import cocaColaLogo from '@framework/assets/customers/svg/cocaCola.svg';
import daimlerTruckLogo from '@framework/assets/customers/svg/daimlerTruck.svg';
import dardenRestaurantsLogo from '@framework/assets/customers/svg/dardenRestaurants.svg';
import delMonteLogo from '@framework/assets/customers/svg/delMonte.svg';
import williamBlairLogo from '@framework/assets/customers/svg/williamBlair.svg';
import enterpriseLogo from '@framework/assets/customers/svg/enterprise.svg';
import fannieMaeLogo from '@framework/assets/customers/svg/fannieMae.svg';
import goldmanSachsLogo from '@framework/assets/customers/svg/goldmanSachs.svg';
import jefferiesLogo from '@framework/assets/customers/svg/jefferies.svg';
import HSBCLogo from '@framework/assets/customers/svg/HSBC.svg';
import lendleaseLogo from '@framework/assets/customers/svg/lendlease.svg';
import mizuhoLogo from '@framework/assets/customers/svg/mizuho.svg';
import morrisonsLogo from '@framework/assets/customers/svg/morrisons.svg';
import mufgLogo from '@framework/assets/customers/svg/mufg.svg';
import nationalBankOfCanadaLogo from '@framework/assets/customers/svg/nationalBankOfCanada.svg';
import nationalGridLogo from '@framework/assets/customers/svg/nationalGrid.svg';
import nationWideLogo from '@framework/assets/customers/svg/nationWide.svg';
import nomuraLogo from '@framework/assets/customers/svg/nomura.svg';
import peletonLogo from '@framework/assets/customers/svg/peloton.svg';
import raymondJamesLogo from '@framework/assets/customers/svg/raymondJames.svg';
import sothebysLogo from '@framework/assets/customers/svg/sothebys.svg';
import toyotaLogo from '@framework/assets/customers/svg/toyota.svg';

const customers: ICustomer[] = [
  {
    src: airFranceLogo.src,
    title: 'Air France',
    width: 115,
    height: 19,
  },
  {
    src: americanAirlinesLogo.src,
    title: 'American Airlines',
    width: 81,
    height: 30,
  },
  {
    src: barclaysLogo.src,
    title: 'Barclays',
    width: 115,
    height: 31,
  },
  {
    src: bnpParibasLogo.src,
    title: 'BNP PARIBAS',
    width: 115,
    height: 25,
  },
  {
    src: chuckCheeseLogo.src,
    title: 'Chuck E. Cheese',
    width: 81,
    height: 30,
  },
  {
    src: creditAgricoleLogo.src,
    title: 'Credit Agricole',
    width: 115,
    height: 27,
  },
  {
    src: cocaColaLogo.src,
    title: 'Coca Cola',
    width: 78,
    height: 30,
  },
  {
    src: daimlerTruckLogo.src,
    title: 'Daimler Truck',
    width: 87,
    height: 30,
  },
  {
    src: dardenRestaurantsLogo.src,
    title: 'Darden Restaurants',
    width: 102,
    height: 31,
  },
  {
    src: delMonteLogo.src,
    title: 'Del Monte',
    width: 41,
    height: 30,
  },
  {
    src: williamBlairLogo.src,
    title: 'WilliamBlair',
    width: 115,
    height: 19,
  },
  {
    src: enterpriseLogo.src,
    title: 'Enterprise',
    width: 115,
    height: 24,
  },
  {
    src: fannieMaeLogo.src,
    title: 'Fannie Mae',
    width: 115,
    height: 31,
  },
  {
    src: goldmanSachsLogo.src,
    title: 'Goldman Sachs',
    width: 71,
    height: 31,
  },
  {
    src: HSBCLogo.src,
    title: 'HSBC',
    width: 115,
    height: 31,
  },
  {
    src: jefferiesLogo.src,
    title: 'Jefferies',
    width: 115,
    height: 31,
  },
  {
    src: lendleaseLogo.src,
    title: 'Lendlease',
    width: 42,
    height: 30,
  },
  {
    src: mizuhoLogo.src,
    title: 'Mizuho',
    width: 99,
    height: 30,
  },
  {
    src: morrisonsLogo.src,
    title: 'Morrisons',
    width: 59,
    height: 30,
  },
  {
    src: mufgLogo.src,
    title: 'MUFG',
    width: 115,
    height: 28,
  },
  {
    src: nationalBankOfCanadaLogo.src,
    title: 'National bank of Canada',
    width: 87,
    height: 31,
  },
  {
    src: nationalGridLogo.src,
    title: 'National grid',
    width: 116,
    height: 25,
  },
  {
    src: nationWideLogo.src,
    title: 'Nation wide',
    width: 30,
    height: 30,
  },
  {
    src: nomuraLogo.src,
    title: 'Nomura',
    width: 115,
    height: 31,
  },
  {
    src: peletonLogo.src,
    title: 'Peleton',
    width: 103,
    height: 30,
  },
  {
    src: raymondJamesLogo.src,
    title: 'Raymond James',
    width: 115,
    height: 31,
  },
  {
    src: sothebysLogo.src,
    title: "Sotheby's",
    width: 116,
    height: 28,
  },
  {
    src: toyotaLogo.src,
    title: 'Toyota',
    width: 115,
    height: 31,
  },
];

export default customers;
